
import PotionIcon from "@/shared/ui/Icon/svg/PotionIcon.vue";
import { defineComponent, PropType } from "vue";
import { Intoxication } from "@/types";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "IntoxicationBar",
	components: { PotionIcon },
	props: {
		intoxication: {
			type: Object as PropType<Intoxication>,
			required: true,
		},
	},
	setup() {
		const store = useCharactersStore();

		const { maxIntoxication } = storeToRefs(store);

		return {
			maxIntoxication,
		};
	},
	computed: {
		percent() {
			return (this.intoxication.current / this.maxIntoxication) * 100;
		},
		gradient() {
			return {
				background: `linear-gradient(${
					this.percent < 100
						? `90deg, #181818 0%, #181818 ${this.percent}%, transparent ${this.percent}%`
						: `90deg, #7E7E7E 0%, #7E7E7E ${
								this.percent - 100
						  }%, #181818 ${this.percent - 100}%`
				})`,
			};
		},
	},
});
